import { render } from "./sdltgd.vue?vue&type=template&id=2d25844f&scoped=true&ts=true"
import script from "./sdltgd.vue?vue&type=script&lang=ts"
export * from "./sdltgd.vue?vue&type=script&lang=ts"

import "./sdltgd.vue?vue&type=style&index=0&id=2d25844f&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d25844f"]])

export default __exports__